<template>
    <div v-if=" order.type!=1" class="order-step order-detail-section mg20">
        <h3>流程进度</h3>
        <el-steps :active="active" finish-status="success">
            <el-step title="产品审核" description="">
            </el-step>
            <el-step title="财务审核" description="">
            </el-step>
            <el-step title="合同审核" description="">
            </el-step>
            <el-step title="完成"></el-step>
        </el-steps>
    </div>
</template>
<script>
    export default {
        props: {
            order: {
                required: true
            },
        },
        data(){
          return {
              active:0
          }
        },
        watch: {
            order(value) {
                this.getMainProgress();
            }
        },
        methods:{
            getMainProgress(){
                if (this.order.business_audit == 1) {
                    this.active = 1;
                }
                if (this.order.finance_audit == 1) {
                    this.active = 2;
                }else{
                    return false;
                }
                if (this.order.contract_audit == 1) {
                    this.active = 4;
                }
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/partial/order_progress.vue